import { FreightService } from '@prisma/client';

export const REQUEST_FORM_LABELS = {
  dropoffByDefault: 'Expected Drop Off',
  dropoffByExw: 'Expected Pick Up',
} as const;

export type RequestFormLabels = {
  dropoffBy: (typeof REQUEST_FORM_LABELS)[keyof typeof REQUEST_FORM_LABELS];
};

export const getRequestFormLabels = (freightService: FreightService | undefined): RequestFormLabels => ({
  dropoffBy:
    freightService === FreightService.EXW
      ? REQUEST_FORM_LABELS.dropoffByExw
      : REQUEST_FORM_LABELS.dropoffByDefault,
});
